var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.5417C19.2532 11.7515 18.9705 12.9451 18.425 14.025C17.7782 15.3191 16.7839 16.4076 15.5535 17.1685C14.3231 17.9294 12.9051 18.3328 11.4583 18.3333C10.2485 18.3365 9.05494 18.0538 7.975 17.5083L2.75 19.25L4.49167 14.025C3.94619 12.9451 3.66351 11.7515 3.66667 10.5417C3.66723 9.09494 4.07056 7.67694 4.83149 6.4465C5.59242 5.21606 6.6809 4.22177 7.975 3.575C9.05494 3.02952 10.2485 2.74684 11.4583 2.75H11.9167C13.8273 2.8554 15.632 3.66186 16.985 5.01495C18.3381 6.36804 19.1446 8.17268 19.25 10.0833V10.5417Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b4f6651df6028aec5b563afe4d70d5a4.svg";
export { ForwardRef as ReactComponent };